<div class="checkbox-component text-size-{{ textSize }}" [class.label-before]="label && labelBefore" [class.container-underline]="underline" [class.bold-label]="boldLabel" [class.has-note]="note" [class.checked]="value">
  <label class="checkbox-component__label" (click)="onToggle()">
    <span>{{ label }}</span>

    @if (note) {
      <span class="checkbox-component__note">{{ note }}</span>
    }
  </label>

  <div class="checkbox-component__checkbox" (click)="onToggle()">
    <input
      type="checkbox"
      [checked]="value"
      [disabled]="disabled"
      (change)="onCheckboxChange($event)"
    >
    <span></span>
  </div>
</div>
